var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStabillity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00004 8.67578L12 12.0529L5.99995 15.4012L0 12.0443L6.00004 8.67578ZM0.301044 12.044L6.00004 15.2326L11.6989 12.0523L5.99995 8.84467L0.301044 12.044Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.150391 3.88257L5.99986 7.14736V13.6504L0.150391 10.4472V3.88257Z",
    fill: "#3E7CB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8495 3.89136L6 7.15562V13.6591L11.8495 10.456V3.89136Z",
    fill: "#30C5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.150391 3.88281L5.99986 0.598877L11.8493 3.89133L5.99986 7.15559L0.150391 3.88281Z",
    fill: "#41EEF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStabillity);
export default __webpack_public_path__ + "static/media/stabillity.1c71a014a8c20011604e903661ac273c.svg";
export { ForwardRef as ReactComponent };